package ru.villawonka.app.presentation.design.components

enum class AppButtonSize {
    LARGE,
    MEDIUM
}